import type { AnalyticsSettingsAddon } from "owa-analytics-types";
import type { AccountKey, MailboxInfo } from "owa-client-types";
import { getAnalyticsAddon } from "owa-analytics-addons";

/**
 * Resolves the AccountKey to use for telemetry routing.
 * Returns 'globalAccount' for special MailboxInfo types (Anonymous, UIB, PST, MSG)
 * that should route through the global collector. Returns undefined for normal
 * MailboxInfo types — the caller should derive the AccountKey from the MailboxInfo directly.
 */
export function getResolvedAccountKeyForTelemetry(mailboxInfo: MailboxInfo | undefined): AccountKey | "globalAccount" | undefined {
    if (!mailboxInfo) {
        return undefined;
    }
    
    try {
        const addon = getAnalyticsAddon<AnalyticsSettingsAddon>("AnalyticsSettings")?.executeNow();
        return addon?.resolveAccountKeyForTelemetry(mailboxInfo);
    }
    catch {
        return undefined;
    }
}
